import { getHdImageUpload, setHdImageUpload } from 'qs-services/Apis/CompanyDetaills/api';
import { sendHdImageSetting } from 'qs-services/WebWorker/master.worker.js';
import { registerCleanupHandler } from 'qs-helpers/ClearSavedData';

const HD_IMAGE_LOCAL_STORAGE_KEY = 'HD_IMAGE_UPLOAD';

let hdImageEnabled = false;

export const getHdImageEnabled = () => hdImageEnabled;

const applyHdImageSetting = enabled => {
  hdImageEnabled = !!enabled;
  sendHdImageSetting(hdImageEnabled);
};

export const rehydrateHdImageSetting = () => {
  const stored = localStorage.getItem(HD_IMAGE_LOCAL_STORAGE_KEY);
  if (stored !== null) {
    applyHdImageSetting(JSON.parse(stored));
  }
};

export const fetchHdImageSetting = () => {
  return getHdImageUpload()
    .then(response => {
      const enabled = response && response.hdImageUpload != null ? response.hdImageUpload : false;
      localStorage.setItem(HD_IMAGE_LOCAL_STORAGE_KEY, JSON.stringify(enabled));
      applyHdImageSetting(enabled);
      return enabled;
    })
    .catch(() => {
      applyHdImageSetting(false);
    });
};

export const saveHdImageSetting = value => {
  return setHdImageUpload(value).then(() => {
    localStorage.setItem(HD_IMAGE_LOCAL_STORAGE_KEY, JSON.stringify(value));
    applyHdImageSetting(value);
  });
};

const cleanupHdImageData = () => {
  hdImageEnabled = false;
  localStorage.removeItem(HD_IMAGE_LOCAL_STORAGE_KEY);
};

registerCleanupHandler(cleanupHdImageData);
